import React from 'react';

import ReactHighcharts from 'react-highcharts';


export function Chart(props: {
  title: string,
  config: any,
}) {
  const config = {
    credits: {enabled: false},
    title: {
      text: props.title,
      style: {
        'color': '#676767',
        'font-size': '28px',
        'font-family': 'Source Sans Pro',
      },
      y: 34
    },
    ...props.config,
  };
  return <ReactHighcharts config={config}/>
}